// angular
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { VideoPlayerComponent } from '@app/core/components/video-player/video-player.component';
// types & env
import { ProductVideoType } from '@app/+products/shared/types/product-video.type';
import { environment } from '@environments/environment';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

@Component({
  selector: 'pwj-product-video',
  standalone: true,
  imports: [
    VideoPlayerComponent,
    TranslateModule,
    TranslateDataPipe,
  ],
  templateUrl: './product-video.component.html',
  styleUrl: './product-video.component.scss',
})
export class ProductVideoComponent {
  public baseUrl: string = environment.baseUrl.base;

  // inputs
  productVideo = input.required<ProductVideoType>();
}
